export type GameAssetManifest = {
  images: Record<string, string>;
};

const manifests = new Map<string, GameAssetManifest>();
const avatarResolvers = new Map<string, (playerId: string) => string>();

export function registerGameAssets(
  slug: string,
  manifest: GameAssetManifest,
  getPlayerAvatarUrl?: (playerId: string) => string
): void {
  manifests.set(slug, manifest);
  if (getPlayerAvatarUrl) {
    avatarResolvers.set(slug, getPlayerAvatarUrl);
  }
}

export function unregisterGameAssets(slug: string): void {
  manifests.delete(slug);
  avatarResolvers.delete(slug);
}

export function getRegisteredAssetManifest(
  slug: string
): GameAssetManifest | undefined {
  return manifests.get(slug);
}

export function getRegisteredPlayerAvatarUrl(
  slug: string,
  playerId: string
): string | undefined {
  return avatarResolvers.get(slug)?.(playerId);
}
